"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var routes_1 = require("./routes"); // Assuming you have a route configuration file
var doshx_controls_web_1 = require("doshx_controls_web");
var SitemapGeneratorPage = function () {
    // Function to generate XML sitemap
    var generateSitemap = function () {
        var urls = routes_1.SiteMapRoutes.map(function (route) { return ({
            loc: "https://thelocalchoice.co.za".concat(route.path),
            lastmod: new Date().toISOString().split("T")[0],
            changefreq: "weekly",
            priority: 0.8,
        }); });
        var xml = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n      <urlset xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\">\n        ".concat(urls
            .map(function (url) { return "\n          <url>\n            <loc>".concat(url.loc, "</loc>\n            <lastmod>").concat(url.lastmod, "</lastmod>\n            <changefreq>").concat(url.changefreq, "</changefreq>\n            <priority>").concat(url.priority, "</priority>\n          </url>\n        "); })
            .join(""), "\n      </urlset>");
        return xml;
    };
    // Function to handle download
    var handleDownload = function () {
        var sitemapContent = generateSitemap();
        var blob = new Blob([sitemapContent], { type: "application/xml" });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "thelocalchoice_sitemap.xml";
        a.click();
    };
    return (react_1.default.createElement("div", { className: "flex flex-row justify-center" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement("div", { className: "flex flex-col items-center justify-center h-full" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Download Sitemap", onClick: function () {
                        handleDownload();
                    } })))));
};
exports.default = SitemapGeneratorPage;
